import ClosebookActions from "./actions";

const INITIAL_STATE = {
  isProcessing: false,
  isError: false,
  data:[],
  errorMessage: [],
  errorInternal: false,
  isProcessingData:false,
  processText: "",
  cutoff: "",
};

function ClosebookReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ClosebookActions.NEW_DATA:
      return INITIAL_STATE;
    case ClosebookActions.AFTER_CHECK:
      return {
        ...state,
        processText: action.payload?.processText,
        cutoff: action.payload?.cutoff,
        isProcessing: false,
      };
    case ClosebookActions.BEFORE_CHECK:
      return {
        ...state,
        processText: "Check status closebook",
        isProcessing: true,
      };
    case ClosebookActions.AFTER_SEARCH:
      return {
        ...state,
        data: action.payload,
        isProcessingData: false,
      };
    case ClosebookActions.BEFORE_SEARCH:
      return {
        ...state,
        processText: "Check status closebook",
        isProcessingData: true,
      };
    case ClosebookActions.SUCCESS_DATA:
      return { ...state, errorInternal: false };
    case ClosebookActions.ERROR_DATA:
      return {
        ...state,
        onSubmit: false,
        errorInternal: false,
        isError: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case ClosebookActions.PROCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: true,
        isError: false,
        isSuccess: false,
      };
    default:
      return state;
  }
}

export default ClosebookReducer;
